export { default } from './BannerWithInfoBoard';
